import { render, staticRenderFns } from "./BasePasswordPlaceholder.vue?vue&type=template&id=27f562a2&scoped=true"
import script from "./BasePasswordPlaceholder.vue?vue&type=script&lang=js"
export * from "./BasePasswordPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./BasePasswordPlaceholder.vue?vue&type=style&index=0&id=27f562a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f562a2",
  null
  
)

export default component.exports